import * as React from "react";
import { Link, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
import _ from "lodash";

// Generic Components imports
import AuditTable from "../../components/AuditTable/AuditTable";

// Zustand store
import { useAppStore } from "../../stores";
import { useLocation, useNavigate } from "react-router-dom";
import { deserializeQueryParamsIntoStr } from "../../commonFunctions";
import GenericSpinner from "components/GenericSpinner/GenericSpinner";
import axios from "axios";

interface IAuditAndHistoryRevisionsProps {
  isAttendee: boolean;
}

const AuditAndHistoryRevisions: React.FunctionComponent<IAuditAndHistoryRevisionsProps> = (props) => {
  // Zustand store
  const setRevisions = useAppStore((state) => state.setRevisions);

  const location = useLocation();

  const navigate = useNavigate();

  const [initialRequestPending, setInitialRequestPending] = React.useState(
    true
  );

  const onRowClick = (data: any) => {
    //history.push(`/audit-and-revisions/revision/${data[0]}`);
  };

  React.useEffect(() => {
    const parsedParams = deserializeQueryParamsIntoStr(location.search);
    setInitialRequestPending(true);
    axios
      .post(`/api/Audit/search`, parsedParams)
      .then((response) => {
        if (response && response.data) {
          const { data } = response;
          setRevisions(data);
        }
        setInitialRequestPending(false);
      })
      .catch((error) => {
        console.log(error);
        setInitialRequestPending(false);
      });
    // return () => {
    //   dispatch(setRevisions([]));
    // };
  }, []);

  return (
    <Grid container size={{ xs: 12 }}>
      {initialRequestPending ? (
        <Grid
          container
          size={{ xs: 12 }}
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <GenericSpinner includeOverlay={false} padding={25} />
        </Grid>
      ) : (
        <Grid container size={{ xs: 12 }}>
          <Grid size={{ xs: 12 }} className="pt-3 pb-3">
            <Link className={"back-btn"} onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}>
              {"< "}Back to Search
            </Link>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Typography variant="subtitle2">
              The search results have been limited to only 10000 records.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12 }} className={"pt-2"}>
            <AuditTable onRowClick={onRowClick} isAttendee={props.isAttendee} />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

export default AuditAndHistoryRevisions;
